module.exports = __webpack_public_path__ + "7ae833e17fb31d18e512910cdd91fe2a.png";